/* RESPONSIBLE TEAM: team-data-foundations */
import type AppService from 'embercom/services/app-service';
import Model, { attr, hasMany } from '@ember-data/model';
import { inject as service } from '@ember/service';
import type AttributeDescriptor from './attribute-descriptor';

export default class InboundTrigger extends Model {
  @service declare appService: AppService;

  @attr('string') declare name: string;
  @attr('string') declare uuid: string;
  @hasMany('workflow-connector/attribute-descriptor', { async: false })
  declare attributeDescriptors: AttributeDescriptor[];
}
